<template>
  <div class="chat-empty">
    <div
      ref="noChatIcon"
      class="chat-empty__icon">
      <messages-icon/>
    </div>
    <span
      ref="noChatText"
      class="chat-empty__text">{{ $t('chat.body') }}</span>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import MessagesIcon from '@/assets/icons/messages.svg';

export default {
  components: {
    MessagesIcon,
  },
  mounted() {
    gsap.from(this.$refs.noChatIcon, 1, { x: -150, opacity: 0 });
    gsap.from(this.$refs.noChatText, 1, { delay: 0.5, y: 50, opacity: 0 });
  },
};
</script>
